import { createFileRoute } from "@tanstack/react-router";
import { HeroDemo } from "@/pages/3d/ux/HeroDemo";

export const Route = createFileRoute("/demo/3d/ux/hero")({
  component: RouteComponent,
});

function RouteComponent() {
  return <HeroDemo />;
}
